"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const eventemitter3_1 = tslib_1.__importDefault(require("eventemitter3"));
function payloadId() {
    const datePart = new Date().getTime() * Math.pow(10, 3);
    const extraPart = Math.floor(Math.random() * Math.pow(10, 3));
    const id = datePart + extraPart;
    return id;
}
exports.payloadId = payloadId;
class BasicProvider extends eventemitter3_1.default {
    constructor(connection) {
        super();
        this._connected = false;
        this.request = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.connection.send(Object.assign(Object.assign({}, params), { id: payloadId(), jsonrpc: '2.0' }));
            return result;
        });
        this.connection = connection;
        if (this.connection.connected) {
            this.connected = true;
        }
    }
    set connected(value) {
        this._connected = value;
        if (value === true) {
            this.emit('open');
            this.emit('connect');
        }
        else {
            this.emit('close');
            this.emit('disconnect');
        }
    }
    get connected() {
        return this._connected;
    }
    open() {
        if (this.connected) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            this.connection.on('disconnect', () => {
                this.connected = false;
                reject();
            });
            this.connection.on('connect', () => {
                this.connected = true;
                resolve();
            });
            this.connection.open();
        });
    }
    close() {
        this.connected = false;
        return this.connection.close();
    }
    send(method, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.connection.send({
                id: payloadId(),
                jsonrpc: '2.0',
                method,
                params: params || {},
            });
            return result;
        });
    }
}
exports.default = BasicProvider;
//# sourceMappingURL=BasicProvider.js.map